<template>
    <section class="comp_overview_home_new">
        <div class="comp_scroller">
            <div class="comp_content">
                <div class="wrp_comp_body" v-on:scroll="handleGlobalScroll($event)">
                    <div class="wrp_comp_table">
                        <section class="welcome">

                            <div style="font-size: 18px">{{ $t('welcome_in') }}</div>

                            <div style="font-size: 18px;font-weight: 300">
                                <div v-if="hotels">
                                    <custom-select
                                        :defaultId="hotelCode"
                                        prevent-select
                                        v-on:change="id=>this.handleHotelChange(id)"
                                        :options="hotels.map(h=>({
                                        id:h.code,
                                        label:h.hotel,
                                        style:h.status ? '' : 'color:#b3b3b3'
                                        }))"/>
                                </div>
                                <div class="elm_subhead" v-else>
                                    <div class="elm_name">{{ hotel }}</div>
                                </div>
                            </div>

                            <div
                                style="font-weight: bold;margin-top: 8px; font-size: 9px; text-transform: uppercase;letter-spacing: 0.9px;">
                                {{ userName }}
                            </div>

                        </section>
                        <section style="display:flex;flex-direction:column;align-items: stretch;align-self: center">
                            <div class="mod--row mod--row-2 mod--row-flex" style="margin-bottom: 0;"
                                 v-if="typeof doughnutChartData === 'object'">
                                <div class="col col--12">
                                    <div class="mod--row mod--row-flex main-graph">
                                        <div class="doughnut-container">
                                            <Doughnut :occupancyData="doughnutChartData.items"/>
                                            <div class="center-text">
                                                <div>{{ Math.round(doughnutChartData.totalPercent) }} %</div>
                                                <div class="secondary">
                                                    {{ Math.round(doughnutChartData.totalTargetPercent) }} %
                                                </div>
                                            </div>
                                        </div>
                                        <ul>
                                            <li v-for="(i) in doughnutChartData.items
                                                    .flatMap(i=>i.items)
                                                    .filter(i=>!['free', 'departures'].includes(i.id))
                                                    .filter(i=>!i.hideFromLegend)"
                                                :key="i.id"
                                                :style="{background: i.background, color:i.color}">
                                                {{ i.value }} {{ i.label }}
                                            </li>
                                            <li class="free-and-departures-group">
                                                <ul>
                                                    <li v-for="(i) in doughnutChartData.items
                                                            .flatMap(i=>i.items)
                                                            .filter(i=>['free', 'departures'].includes(i.id))
                                                            .filter(i=>!i.hideFromLegend)
                                                            .reverse() /*reverse kvůli předřazení volné před odjezdy, není čas na to to dělat inteligentně...*/"
                                                        :key="i.id"
                                                        :style="{border: i.id === 'departures' ? '2px dashed #FFB300' : 'none'}">
                                                        {{ i.value }} {{ i.label }}
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <error v-else-if="doughnutChartData !== undefined" :error="doughnutChartData"/>

                            <div class="horizontal-cards" v-if="typeof horizontalCardsData === 'object'">
                                <a class="help" v-on:click.prevent="showPopup(8027043336861)"
                                   style="display:block;align-self: end;margin-bottom: 10px;">
                                    <i class="icon icon--question-circle-fill"/>
                                </a>
                                <ul>
                                    <li>
                                        <router-link to="/overview/arrivals">
                                            <div class="value">
                                                {{
                                                    horizontalCardsData.remainingArrivals
                                                }}/{{ horizontalCardsData.totalArrivals }}
                                            </div>
                                            <label>{{ $t('arrivals') }}</label>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/overview/guests">
                                            <div class="value">{{
                                                    horizontalCardsData.occupiedRoomsCount
                                                }}({{ horizontalCardsData.currentGuestsCount }}<i
                                                    class="icon icon--person-fill"
                                                    style="margin-top: -3px; vertical-align: middle; font-size: 16px;"/>)
                                            </div>
                                            <label>{{ $t('current_guests_short') }}</label>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/overview/departures">
                                            <div class="value">
                                                {{
                                                    horizontalCardsData.remainingDepartures
                                                }}/{{ horizontalCardsData.totalDepartures }}
                                            </div>
                                            <label>{{ $t('departures') }}</label>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                            <error v-else-if="horizontalCardsData !== undefined" :error="horizontalCardsData"/>
                        </section>

                        <section style="user-select: none" v-touch:swipe.left="daysPercentageSwipeLeft"
                                 v-touch:swipe.right="daysPercentageSwipeRight">
                            <h1 class="part_ui_heading" style="display: flex; align-items: center">
                                <span>{{ $t('obsazenost_v_procentech') }}</span>
                                <div style="flex: 1"/>
                                <router-link to="/overview/occupancy">
                                    <button class="occupancy-button"><span class="icon icon--table"/></button>
                                </router-link>
                            </h1>
                            <template v-if="typeof daysOccupancyData === 'object'">
                                <DateInputHeader v-model="occupancyDate" increment="10"/>
                                <div class="wrp_comp_graph" :class="[loading ? 'state-loading' : '']" draggable="false">
                                    <div class="mod--row mod--row-2 mod--row-horizontal mod--row-flex"
                                         draggable="false">
                                        <div class="col mod--flex-grow" v-for="item in daysOccupancyData"
                                             draggable="false">
                                            <router-link draggable="false"
                                                         :to="`/bookings/overview?dateFrom=${item.date.format('yyyy-MM-DD')}&dateTo=${item.date.format('yyyy-MM-DD')}`">
                                                <DayPercentBar v-bind="item"/>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <error v-else-if="daysOccupancyData !== undefined" :error="daysOccupancyData"/>
                        </section>

                        <section>
                            <h1 class="part_ui_heading"><span>{{ $t('rooms_state') }}</span></h1>
                            <HorizontalBar :items="roomsData" :colorize="true" v-if="typeof roomsData === 'object'"/>
                            <error v-else-if="roomsData !== undefined" :error="roomsData"/>
                        </section>

                        <section class="stats-cards" v-if="Array.isArray(statsCardsData)">
                            <ul>
                                <router-link v-for="i in statsCardsData"
                                             :key="i.id"
                                             class="holder"
                                             :to="'/overview/graph/'+i.graph"
                                             :is="!i.graph || !Number.isFinite(i.value) ? 'span' : 'router-link'">
                                    <li :class="{'disabled':!i.graph || !Number.isFinite(i.value)}">
                                        <header>
                                            <label>{{ i.label }}</label>
                                            <a class="help" v-on:click.prevent="showPopup(i.zenDeskArticleId)">
                                                <i class="icon icon--question-circle-fill"/>
                                            </a>
                                        </header>
                                        <template v-if="Number.isFinite(i.value)">
                                            <OverviewGraphChange :diff-percent="i.diffPercent"
                                                                 v-if="i.graph !== 'booking-window'"/>
                                            <div v-else style="flex:1"/>
                                            <OverviewGraphValue :value="i.value" :unit="i.unit"/>
                                            <a class="graph" v-if="i.graph">
                                                <i class="icon icon--report"/>
                                                {{
                                                    $t('graph')
                                                }}</a>
                                        </template>
                                        <div class="no-permissions" v-on:click.prevent="showPopup('6914590239133')"
                                             v-else>
                                            <i class="icon icon--exclamation-triangle-fill"/>
                                            <a>{{ $t('no_permission') }}</a>
                                        </div>
                                    </li>
                                </router-link>
                            </ul>
                        </section>
                        <error v-else-if="statsCardsData !== undefined" :error="statsCardsData"/>

                        <section class="new-reservations-info">
                            <h1 class="part_ui_heading"><span>{{ $t('new_bookings') }}</span></h1>
                            <OverviewReservations :all="false"/>
                            <router-link to="/bookings/overview"
                                         v-slot="{href, route, navigate}" custom>
                                <button class="root-button contained" @click="navigate">
                                    {{ $t('bookings_overview_all') }}
                                </button>
                            </router-link>
                        </section>

                        <section class="hosts-structure-info">
                            <h1 class="part_ui_heading"><span>{{ $t('guests_structure') }}</span></h1>
                            <HorizontalBar :items="guestsGroupsData" unit="%"
                                           v-if="typeof guestsGroupsData === 'object'"/>
                            <error v-else-if="guestsGroupsData !== undefined" :error="guestsGroupsData"/>

                            <HorizontalBar :items="guestsNationalityData" unit="%"
                                           v-if="typeof guestsNationalityData === 'object'"/>
                            <error v-else-if="guestsNationalityData !== undefined" :error="guestsNationalityData"/>
                        </section>

                        <button class="root-button"
                                onclick="Array.from(document.getElementsByClassName('comp_scroller')).forEach(e=>e.scrollTo({top:0,behavior:'smooth'}))">
                            <i class="icon icon--chevron-up"/>{{ $t('top') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Doughnut from '../part/chart/doughnut';
import DateInputRangeHeader from '../part/item/date_input_range_header';
import DateInputHeader from '../part/item/date_input_header';
import DayPercentBar from '../part/item/day_percent_bar';
import HorizontalBar from '../part/item/horizontal_bar';
import OverviewGraphChange from '../part/ui/overview-graph-change';
import OverviewGraphValue from '../part/ui/overview-graph-value';
import OverviewReservations from '../part/ui/overview-reservations';
import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import {fetchZenDesk, openHotel, openHotelDomain} from '../../main';
import CustomSelect from '../part/ui/custom-select';
import Error from '../part/ui/error.vue';

Vue.use(Vue2TouchEvents);

const diagonalPattern = (function createDiagonalPattern() {
    const size = 10;
    const stroke = 5;
    const strokeOffset = stroke / 2;

    let shape = document.createElement('canvas')
    shape.width = size
    shape.height = size

    let c = shape.getContext('2d')

    c.fillStyle = '#FFB300'
    c.fillRect(0, 0, shape.width, shape.height)

    c.strokeStyle = '#D7E2E6'
    c.lineWidth = stroke

    c.moveTo(size / 2 - strokeOffset, -strokeOffset);
    c.lineTo(size + strokeOffset, size / 2 + strokeOffset);
    c.moveTo(-strokeOffset, size / 2 - strokeOffset);
    c.lineTo(size / 2 + strokeOffset, size + strokeOffset);
    c.stroke();

    return c.createPattern(shape, 'repeat')
})();

export default {
    name: 'overview-home',
    components: {
        Error,
        CustomSelect,
        OverviewGraphValue,
        OverviewGraphChange,
        OverviewReservations,
        HorizontalBar, DayPercentBar, DateInputHeader, DateInputRangeHeader, Doughnut
    },
    watch: {
        occupancyDate: function (date) {
            this.fetchOccupancyData(date)
        },
        hotelCode: function (newCode, oldCode) {
            if (oldCode !== newCode && oldCode) {
                this.handleHotelChange()
            }
        }
    },
    data() {
        return {
            loading: false,
            check_in_room_count: null,
            check_out_room_count: null,
            free_room_count: null,
            occupied_room_count: null,
            total_room_count: null,
            today_option_room_count: null,
            waiting_count: null,
            price_per_room: null,
            minimum_price: null,
            national_currency: {},
            occupancyDate: new Date(),
            doughnutChartData: undefined,
            daysOccupancyData: [],
            roomsData: undefined,
            horizontalCardsData: undefined,
            guestsNationalityData: undefined,
            guestsGroupsData: undefined,
            statsCardsData: undefined,
            userName: undefined,

            hotelCode: null,
            hotel: null,
            hotels: null
        };
    },
    mounted() {
        this.loading = true;

        axios({
            data: `{
                    basicInfo {
                        total_room_count,

                        check_in_room_count,
                        total_check_in_room_count,

                        check_out_room_count,
                        total_check_out_room_count,

                        check_out_guest_count,

                        free_room_count,
                        occupied_room_count,
                        total_guests_count,
                        foreign_guests_count,
                        current_room_count,
                        current_guest_count,
                        group_guests_count,
                        clean_rooms,
                        unclean_rooms,
                        out_of_order,
                        waiting_count,
                        today_option_room_count,
                        national_currency {
                            symbol
                        }
                    }
                    currentUser {
                        realname
                        lang
                    }
                }`
        }).then(response => {
            const basicInfo = response.data.data.basicInfo

            // TODO takhle ne...
            for (var propName in basicInfo) {
                this[propName] = basicInfo[propName];
            }

            this.extractOccupancyChartData(basicInfo)
            this.extractHorizontalCardsData(basicInfo)
            this.extractRoomsData(basicInfo)
            this.extractGuestsStructureData(basicInfo)

            // TODO no tohle je teda pěkný shit - používá se opravdu globálně v nastavení apod. takže celá aplikace spoléhá na to, že se prvně načte dashboard a uloží tuto hodnotu do localStorage
            localStorage.setItem('currency', this.national_currency.symbol);
            // localStorage.setItem('minimum_price', this.minimum_price);

            this.userName = response.data.data.currentUser.realname
        }).catch(error => {
            const code = error.code ? error.code : -1
            this.doughnutChartData = code
            this.horizontalCardsData = code
            this.roomsData = code
            this.guestsGroupsData = code
            this.guestsNationalityData = code
        }).finally(() => {
            this.loading = false;
        });

        this.fetchOccupancyData(this.occupancyDate);
        this.fetchStatsCardsData()

        // FIXME duplicita z header
        this.$root.$on('login', () => {
            this.hotelCode = localStorage.getItem('hotelCode');
            this.hotel = localStorage.getItem('hotel');
            this.hotels = JSON.parse(localStorage.getItem('chainHotels'))

            if (this.hotels.length <= 1) {
                this.hotels = false
            }

            if (localStorage.getItem('locale') === null) {
                axios({
                    data: `{
                    currentUser {
                        lang
                    }
                }`
                }).then(response => {
                    let locale = response.data.data.currentUser.lang
                    if (locale) {
                        locale = locale.substring(0, 2)
                    } else {
                        locale = 'cs'
                    }
                    localStorage.setItem('locale', locale)
                    moment.locale(locale)
                    this.$root.$i18n.locale = locale
                })
            }
        });

        if (localStorage.getItem('hotel')) {
            this.hotel = localStorage.getItem('hotel');
        }

        if (localStorage.getItem('hotelCode')) {
            this.hotelCode = localStorage.getItem('hotelCode');
        }

        if (localStorage.getItem('chainHotels')) {
            this.hotels = JSON.parse(localStorage.getItem('chainHotels'));
            if (this.hotels.length <= 1) {
                this.hotels = false
            }
        }
        //---------------------------
    },
    methods: {
        extractOccupancyChartData: function (basicInfo) {
            const occupiedCount = (basicInfo.current_room_count ? basicInfo.current_room_count : 0)
            const targetOccupiedCount = (basicInfo.occupied_room_count ? basicInfo.occupied_room_count : 0)
            const remainingArrivals = basicInfo.check_in_room_count ? basicInfo.check_in_room_count : 0
            const remainingDepartures = basicInfo.check_out_room_count ? basicInfo.check_out_room_count : 0

            const dataset2 = {
                weight: 3,
                items: [
                    {
                        id: 'occupied',
                        label: this.$t('graph_occupied'),
                        value: occupiedCount,
                        background: '#FFD200',
                        color: '#5e544a'
                    },
                    {
                        id: 'departures',
                        label: this.$t('graph_departures'),
                        value: remainingDepartures,
                        chartBackgroundOverride: diagonalPattern,
                        background: '#FFB300',
                        color: '#5e544a'
                    },
                    {
                        id: 'free',
                        label: this.$t('graph_free'),
                        chartValueOverride: basicInfo.free_room_count - remainingDepartures + remainingArrivals,
                        value: basicInfo.free_room_count,
                        background: '#D7E2E6',
                        color: '#5e544a'
                    },
                    {
                        id: 'fault',
                        label: this.$t('graph_fault'),
                        value: basicInfo.out_of_order,
                        background: '#ff0000',
                        color: '#5e544a',
                        hideFromLegend: true
                    },
                ]
            }

            const dataset1 = {
                weight: 1,
                items: [
                    {
                        id: 'remaining_arrivals',
                        label: this.$t('graph_remaining_arrivals'),
                        value: remainingArrivals,
                        background: '#2EB375',
                        color: 'white'
                    },
                    {
                        id: 'rest',
                        value: dataset2.items.map(i => i.value).reduce((p, c) => p + c, 0),
                        background: '#D7E2E6',
                        color: '#5e544a',
                        hideFromLegend: true
                    }
                ]
            }

            this.doughnutChartData = {
                totalPercent: (basicInfo.total_room_count > 0 ? (occupiedCount/* + remainingDepartures*/) / basicInfo.total_room_count : 0) * 100,
                totalTargetPercent: (basicInfo.total_room_count > 0 ? targetOccupiedCount / basicInfo.total_room_count : 0) * 100,
                items: [dataset1, {
                    weight: 0.6,
                    items: []
                }, dataset2]
            }
        },
        fetchStatsCardsData: function () {
            axios({
                data: `{
                        dailyStatistics(date_from: "${moment().subtract(7, 'd').format('YYYY-MM-DD')}", date_to: "${moment().format('YYYY-MM-DD')}") {
                            revenue,
                            adr,
                            rev_par,
                            alos
                        }
                        basicInfo {
                          national_currency {
                            symbol
                          }
                        }
                        averageBookingWindow(date_from: "${moment().subtract(365, 'd').format('YYYY-MM-DD')}", date_to: "${moment().format('YYYY-MM-DD')}")
                    }`
            }).then(response => {
                const {
                    data: {
                        data: {
                            dailyStatistics,
                            basicInfo: {national_currency: {symbol: currencySymbol}},
                            averageBookingWindow
                        }
                    }
                } = response

                const previous = dailyStatistics[0]
                const current = dailyStatistics[7]

                const diffPercent = (field) => {
                    return (current[field] / previous[field] - 1) * 100
                }

                this.statsCardsData = [{
                    id: 'adr',
                    label: 'ADR',
                    diffPercent: diffPercent('adr'),
                    value: current.adr !== null ? Number(current.adr) : null,
                    unit: currencySymbol,
                    graph: 'adr',
                    zenDeskArticleId: '7834340707729-Average-Daily-Rate'
                }, {
                    id: 'trzby',
                    label: this.$t('earnings'),
                    diffPercent: diffPercent('revenue'),
                    value: current.revenue !== null ? Number(current.revenue) : null,
                    unit: currencySymbol,
                    graph: 'trzby',
                    zenDeskArticleId: '7835431525777-Tržby'
                }, {
                    id: 'revpar',
                    label: 'RevPAR',
                    diffPercent: diffPercent('rev_par'),
                    value: current.rev_par !== null ? Number(current.rev_par) : null,
                    unit: currencySymbol,
                    graph: 'revpar',
                    zenDeskArticleId: '7835511413393-RevPAR'
                }, {
                    id: 'alos',
                    label: 'ALoS',
                    diffPercent: diffPercent('alos'),
                    value: current.alos !== null ? Number(current.alos) : null,
                    unit: this.$t('days'),
                    graph: 'alos',
                    zenDeskArticleId: '7835503423377-Average-Length-of-Stay'
                }, {
                    id: 'booking_window',
                    label: 'Booking window',
                    value: averageBookingWindow !== null ? Number(averageBookingWindow) : null,
                    unit: this.$t('days'),
                    graph: 'booking_window',
                    zenDeskArticleId: '7835579047953-Booking-window'
                }]
            }).catch(error => {
                this.statsCardsData = error.code ? error.code : -1
            });
        },
        extractGuestsStructureData: function (basicInfo) {
            const totalGuestsCount = basicInfo.total_guests_count ? basicInfo.total_guests_count : 0
            const foreignersCount = basicInfo.foreign_guests_count ? basicInfo.foreign_guests_count : 0
            const groupGuestsCount = basicInfo.group_guests_count ? basicInfo.group_guests_count : 0

            this.guestsNationalityData = [
                {
                    label: this.$t('guests_structure_foreigners'),
                    value: Math.round(foreignersCount / totalGuestsCount * 100),
                    color: '#7F735C',
                }, {
                    label: this.$t('guests_structure_natives'),
                    value: Math.round((totalGuestsCount - foreignersCount) / totalGuestsCount * 100),
                    color: '#FFD200',
                },
            ]

            this.guestsGroupsData = [
                {
                    label: this.$t('guests_structure_individuals'),
                    value: Math.round((totalGuestsCount - groupGuestsCount) / totalGuestsCount * 100),
                    color: '#7F735C',
                }, {
                    label: this.$t('guests_structure_groups'),
                    value: Math.round(groupGuestsCount / totalGuestsCount * 100),
                    color: '#FFD200',
                },
            ]
        },
        extractHorizontalCardsData: function (basicInfo) {
            this.horizontalCardsData = {
                remainingArrivals: basicInfo.check_in_room_count ? basicInfo.check_in_room_count : 0,
                totalArrivals: basicInfo.total_check_in_room_count ? basicInfo.total_check_in_room_count : 0,
                occupiedRoomsCount: basicInfo.current_room_count + basicInfo.check_out_room_count,
                currentGuestsCount: basicInfo.current_guest_count + basicInfo.check_out_guest_count,
                remainingDepartures: basicInfo.check_out_room_count,
                totalDepartures: basicInfo.total_check_out_room_count,
            }
        },
        extractRoomsData: function (basicInfo) {
            this.roomsData = [
                {
                    label: this.$t('rooms_state_cleaned'),
                    value: basicInfo.clean_rooms ? basicInfo.clean_rooms : 0,
                    color: '#2EB375',
                }, {
                    label: this.$t('rooms_state_not_cleaned'),
                    value: basicInfo.unclean_rooms ? basicInfo.unclean_rooms : 0,
                    color: '#7F735C',
                }, {
                    label: this.$t('rooms_state_fault'),
                    value: basicInfo.out_of_order ? basicInfo.out_of_order : 0,
                    color: '#FF0000',
                },
            ]
        },
        daysPercentageSwipeLeft: function () {
            this.occupancyDate = moment(this.occupancyDate).add(10, 'days').toDate()
        },
        daysPercentageSwipeRight: function () {
            this.occupancyDate = moment(this.occupancyDate).add(-10, 'days').toDate()
        },
        fetchOccupancyData: function (date) {
            axios({
                data: '{occupancyChart(date_from: "' + moment(date).format('YYYY-MM-DD') + '", date_to: "' + moment(date).add(9, 'd').format('YYYY-MM-DD') + '")}'
            }).then(response => {
                let responseData = JSON.parse(response.data.data.occupancyChart);

                this.daysOccupancyData = Object.keys(responseData.dates).map(d => ({
                    percentage: Math.round(100 * responseData.dates[d].occupied_rooms_count / responseData.real_room_count),
                    date: moment(d)
                }));
            }).catch(error => {
                this.daysOccupancyData = error.code ? error.code : -1
            });
        },
        showPopup(articleId) { // FIXME udělat jako samostatnou komponentu
            fetchZenDesk(articleId)
                .then(article => {
                    let title;
                    let body;
                    if (article === 'not-found') {
                        title = 'Article not found'
                        body = 'Help is available for Czech or English. To display the help, change the language of the application in the settings.'
                    } else {
                        title = article.title
                        body = article.body
                    }

                    // FIXME udělat pořádně
                    const el = document.getElementById('popup');
                    el.innerHTML = '<div class=\'hint\'>' +
                        '<h2>' + title + '</h2>' +
                        body
                        +
                        '<button onclick=\'document.getElementById("popup").classList.remove("visible")\' class=\'close\'><span class="icon icon--x-circle-fill"></span></button>' +
                        '</div>'
                    el.classList.add('visible')
                })
        },

        // FIXME duplicita z header
        handleHotelChange: function (hotelcode) {
            if (hotelcode !== this.hotelCode) {
                //localStorage.setItem('hotelCode', hotelcode);
                //router.push('/logout')
                openHotel(hotelcode)
            }
        }
        // -------------------------
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/overview-home-new.vue